import { connect } from "react-redux";
import { injectIntl } from "@ai360/core/intl";

import { actions as fileImportActions, selectors as fileImportSelectors } from "~/file-import";
import { getTheUserPersonalityId, getTheUserLockCustomer } from "~/login/selectors";

import * as selectors from "../../../selectors";
import * as actions from "../../../actions";
import * as panelActions from "../../../../../actions";
import { FieldBoundaryPanel_, IFieldBoundaryPanelProps } from "../components/field-boundary-panel";

const mapStateToProps = (state): Partial<IFieldBoundaryPanelProps> => ({
    agvanceFieldList: selectors.getAgvanceFieldList(state),
    agvanceOrgLevelList: selectors.getAgvanceOrgLevelList(state),
    getImportFileInfo: (importFileGuid) =>
        fileImportSelectors.getImportFileInfo(state, importFileGuid),
    ignoreFarm: selectors.getIgnoreFarm(state),
    importFieldBoundaries: selectors.getImportFieldBoundaries(state),
    importFieldList: selectors.getImportFieldList(state),
    isLoading: selectors.getIsLoading(state),
    isLockCustomer: getTheUserLockCustomer(state),
    personalityId: getTheUserPersonalityId(state),
    selectedImportFieldIndex: selectors.getSelectedImportFieldIndex(state),
    columnSelections: selectors.getImportColumnSelectionStore(state),
});

const mapDispatchToProps = (dispatch): Partial<IFieldBoundaryPanelProps> => ({
    applyBoundaryColumnSelection: () => dispatch(actions.applyBoundaryColumnSelection()),
    closeImportWizard: () => dispatch(panelActions.closeImportWizard()),
    fetchAgvanceFieldList: (customerGuid) => dispatch(actions.fetchAgvanceFieldList(customerGuid)),
    fetchAgvanceOrgLevelList: (customerGuid) =>
        dispatch(actions.fetchAgvanceOrgLevelList(customerGuid)),
    onSetFieldsToResurface: (fieldGuids) => dispatch(actions.setFieldsToResurface(fieldGuids)),
    setIgnoreFarm: (guids, val) => dispatch(actions.setIgnoreFarm(guids, val)),
    setImportFieldList: (d) => dispatch(actions.setImportFieldList(d)),
    setIsLoading: (flag) => dispatch(actions.setIsLoading(flag)),
    setSelectedImportFieldIndex: (guid) => dispatch(actions.setSelectedImportFieldIndex(guid)),
    updateImportBoundary: (request, callback) =>
        dispatch(actions.updateImportBoundary(request, callback)),
    updateImportFileInfos: (importFileInfos) =>
        dispatch(fileImportActions.updateImportFileInfos(importFileInfos)),
});

export const FieldBoundaryPanel = connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(FieldBoundaryPanel_));
